import { ID } from '@ianesthesie-kit/services';
import { PatchableMedicalService } from '../../patchableMedical.service';
import { PostopSurgeryInfo } from './postopSurgeryInfo.model';

export class PostopSurgeryInfoService extends PatchableMedicalService<PostopSurgeryInfo> {
  private static INSTANCE_BY_ID: PostopSurgeryInfoService;

  private constructor(patientId: string) {
    super('/postop-surgery-info', patientId);
  }

  public static getInstance(patientId: ID): PostopSurgeryInfoService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new PostopSurgeryInfoService(patientId);
    }

    return this.INSTANCE_BY_ID;
  }
}
